/** @format */

export { authClient } from './auth-client';

export {
    login,
    logout,
    quickSignUp,
    signUp,
    upgradeAuthLinkToJWT,
    getUser,
    getPasswordResetHash,
    isPasswordResetHashValid,
    resetPassword,
    getAddressBook,
    addAddress,
    updateAddress,
    verifyCustomerEmail,
    getSavedProducts,
    addSavedProduct,
    removeSavedProduct,
    updateMarketingPreference,
    getSavedModels,
    addSavedModel,
    removeSavedModel,
    updatePersonalInformation,
    updatePassword,
    geolocateUser,
    getUserPhoneNumbers,
    deletePhoneNumber,
    createPhoneNumber,
    updatePhoneNumber,
    sendVerification,
    getAnonymousToken,
    getEmailVerifyPathAndHash,
    verify,
    UpdateMarketingPreferenceChoice,
} from './requests';

export {
    type PersonalDetails,
    type CustomerPhoneNumber,
    type CustomerPhoneNumberResponse,
} from './config/types';
